<template>
  <v-reports
    v-model="page"
    v-bind:headers="headers"
    v-bind:update="loadData"
    v-bind:data="data"
    v-bind:numPages="numPages"
    :data_loading="data_loading"
    @change-pagination="changePagination"
    workgroup-order
  >
    <template #header>
      <v-tabs v-model="mytab" fixed-tabs height="100" icons-and-text right>
        <v-tab>
          {{ total_confirm_complete }} {{ $t(`confirm_complete`) }}
          <v-icon x-large color="#607D8B">mdi-check-all</v-icon>
        </v-tab>
        <v-tab>
          {{ total_completed }} {{ $t(`completed`) }}
          <v-icon x-large color="#4CAF50">mdi-check</v-icon>
        </v-tab>
      </v-tabs>
    </template>
  </v-reports>
</template>

<script>
export default {
  name: "workgroup-order-report",
  data: () => ({
    data_loading: false,
    data: [],
    numPages: 1,
    page: 1,
    params: null,
    mytab: 0,
    total_confirm_complete: 0,
    total_completed: 0,
  }),
  computed: {
    headers() {
      return [
        {
          text: this.$t("order_number"),
          value: "order_number",
          available: true,
        },
        { text: this.$t("priority"), value: "priority", available: true },
        { text: this.$t("created_at"), value: "createdAt", available: true },
        { text: this.$t("comment"), value: "comment", available: true },
        { text: this.$t("state"), value: "state", available: true },
      ];
    },
  },
  watch: {
    page() {
      if (!this.params) return;
      this.loadData(this.params);
    },
    mytab() {
      if (!this.params) return;
      if (this.page != 1) {
        this.page = 1;
        return;
      }
      this.loadData(this.params);
    },
  },
  methods: {
    changePagination(page) {
      this.page = page;
    },
    async loadData(params) {
      this.params = params;
      this.data_loading = true;
      let start_date = new Date(params.start_date).getTime();
      let end_date = new Date(params.end_date).getTime();
      const result = this.$communicator.then(
        this,
        await this.$communicator("workgroup_order_report", {
          params: {
            start_time: start_date,
            end_time: end_date,
            limit: 10,
            page: this.page,
            tab: this.mytab,
          },
        })
      );
      if (result && result.data instanceof Array) {
        this.data = result.data;
        this.numPages = Math.ceil(result.total / 10);
        this.total_confirm_complete = result.total_confirm_complete;
        this.total_completed = result.total_completed;
        if (!this.numPages) {
          this.numPages = 1;
        }
      } else {
        this.data = [];
        this.numPages = 1;
        this.page = 1;
        this.total_confirm_complete = 0;
        this.total_completed = 0;
      }
      this.data_loading = false;
    },
  },
  mounted() {},
};
</script>
